module.exports = __webpack_public_path__ + "img/icb-del-novice-m@3x.eb3a5f33.png";